import React, {Component} from 'react';

const jQuery = window.jQuery,
	$ = jQuery;

class PortfolioMenu extends Component {
	componentDidMount() {
		$('.portfolio-menu a').on('click', function(e) {
			e.preventDefault();

			if ($(this).parent('li').hasClass('active')) {
				return false;
			} else {
				$(this).parent('li').addClass('active').siblings('li').removeClass('active');
			}
		});
	}

	render() {
		const {translate, items} = this.props;
		return (
			<div className="portfolio-menu">
				<ul>
					<li className="filter active" data-filter="all"><a>{translate('all')}</a></li>
					{items.map((item, index) => (
						<li key={index} className="filter" data-filter={item.filter}>
							<a>{translate(item.text)}</a>
						</li>
					))}
				</ul>
			</div>
		);
	}
}

export default PortfolioMenu;



// WEBPACK FOOTER //
// ./src/components/elements/Portfolio/PortfolioMenu.js